import { Job } from './model';
import { FlattenedDroppedData, WebkitFile } from '@myua/dropzone';
import { createAction } from '@reduxjs/toolkit';

export const filesSelectedForUpload = createAction<
  { files: FlattenedDroppedData },
  'creativeHub/uploader/filesSelectedForUpload'
>('creativeHub/uploader/filesSelectedForUpload');
export const workflowUploadRequested = createAction<
  {
    groupID: string;
    groupName: string;
    files: WebkitFile[];
    parentNodeID: number;
    parentIsAssetLab: boolean;
  },
  'creativeHub/uploader/workflowUploadRequested'
>('creativeHub/uploader/workflowUploadRequested');
export const groupRestarted = createAction<
  { groupID: string },
  'creativeHub/uploader/groupRestarted'
>('creativeHub/uploader/groupRestarted');
export const groupDeleted = createAction<{ groupID: string }, 'creativeHub/uploader/groupDeleted'>(
  'creativeHub/uploader/groupDeleted',
);
export const cancelAllJobs = createAction<void, 'creativeHub/uploader/cancelAllJobs'>(
  'creativeHub/uploader/cancelAllJobs',
);
export const jobUpdated = createAction<
  { jobID: string; jobProps: Partial<Job> },
  'creativeHub/uploader/jobUpdated'
>('creativeHub/uploader/jobUpdated');
export const jobsInserted = createAction<{ jobs: Job[] }, 'creativeHub/uploader/jobsInserted'>(
  'creativeHub/uploader/jobsInserted',
);

export const jobRestarted = createAction<{ jobID: string }, 'creativeHub/uploader/jobRestarted'>(
  'creativeHub/uploader/jobRestarted',
);

export const groupInserted = createAction<
  { groupID: string; groupName: string },
  'creativeHub/uploader/groupInserted'
>('creativeHub/uploader/groupInserted');
export const dropzoneFilesDropped = createAction<
  { files: FlattenedDroppedData },
  'creativeHub/uploader/dropzoneFilesDropped'
>('creativeHub/uploader/dropzoneFilesDropped');
export const folderToCreativeCancelled = createAction<
  void,
  'creativeHub/uploader/folderToCreativeCancelled'
>('creativeHub/uploader/folderToCreativeCancelled');

export const mappingRequestFinished = createAction<
  { uuid: string },
  'creativeHub/uploader/mappingRequestFinished'
>('creativeHub/uploader/mappingRequestFinished');
export const mappingRequestStarted = createAction<
  { uuid: string },
  'creativeHub/uploader/mappingRequestStarted'
>('creativeHub/uploader/mappingRequestStarted');
export const setTagsButtonClicked = createAction<
  { groupID: string },
  'creativeHub/uploader/setTagsButtonClicked'
>('creativeHub/uploader/setTagsButtonClicked');
